import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Input } from "./ContactForm";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", password: "", phone: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const set = (k, v) => setForm({ ...form, [k]: v });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await register(form);
      navigate("/mis-reportes");
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto space-y-6">
      <h1 className="font-heading text-2xl font-bold text-[#0F172A]">Crear cuenta</h1>
      <form onSubmit={submit} className="space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <Input label="Nombre" testid="register-firstname" value={form.first_name} onChange={(v) => set("first_name", v)} required />
          <Input label="Apellido" testid="register-lastname" value={form.last_name} onChange={(v) => set("last_name", v)} required />
        </div>
        <Input label="Correo electrónico" testid="register-email" type="email" value={form.email} onChange={(v) => set("email", v)} required />
        <Input label="Teléfono (privado)" testid="register-phone" value={form.phone} onChange={(v) => set("phone", v)} />
        <Input label="Contraseña" testid="register-password" type="password" value={form.password} onChange={(v) => set("password", v)} required />
        {error && <p className="text-sm text-[#DC2626]" data-testid="register-error">{error}</p>}
        <button type="submit" disabled={submitting} data-testid="register-submit-btn"
          className="w-full h-14 rounded-xl bg-[#1E3A8A] text-white font-semibold hover:bg-[#1E40AF] disabled:opacity-50">
          {submitting ? "Creando…" : "Crear cuenta"}
        </button>
      </form>
      <p className="text-sm text-[#475569]">¿Ya tienes cuenta? <Link to="/login" className="text-[#1E3A8A] font-medium underline" data-testid="register-login-link">Inicia sesión</Link></p>
    </div>
  );
}
